import moment from 'moment';

export const isMember = customer => {
  // if no org cannot be members
  if (!customer || !customer.organization) {
    return false;
  }
  return customer.organization.isMember;
};

export const isValidPrice = (event, isMember) => price => {
  let shouldInclude =
    !price.isGuestPrice && !(isMember && !price.isMemberPrice);
  if (price.isTable) {
    shouldInclude =
      shouldInclude && price.numberOfSeats <= event.numberOfSeatsAvailable;
  }
  return shouldInclude;
};

export const buildDateStr = ({
  startDate,
  endDate,
  timeZoneDescriptionLocal,
  timeZoneOffsetLocal,
}) => {
  const offset = timeZoneOffsetLocal
    ? timeZoneOffsetLocal
        .split(':')
        .slice(0, 2)
        .join(':')
    : '00:00';

  const start = moment(startDate).utcOffset(offset);
  const end = moment(endDate).utcOffset(offset);

  if (start.isSame(end, 'day')) {
    // returns formated single date
    return (
      start.format('MMMM Do, YYYY[\n]h:mm a[ - ]') +
      end.format(`h:mm a [${timeZoneDescriptionLocal}]`)
    );
  }
  // formatted multi dates
  return (
    start.format(`MMMM Do, YYYY h:mm a [${timeZoneDescriptionLocal}] -[\n]`) +
    end.format(`MMMM Do, YYYY h:mm a [${timeZoneDescriptionLocal}]`)
  );
};

export const buildDateStrSimple = ({
  startDate,
  timeZoneDescriptionLocal,
  timeZoneOffsetLocal,
}) => {
  const offset = timeZoneOffsetLocal
    ? timeZoneOffsetLocal
        .split(':')
        .slice(0, 2)
        .join(':')
    : '00:00';
  return moment(startDate).utcOffset(offset).format('MMMM Do, YYYY');
};

export const showLocation = ({location, isRemote}) => {
  const { latitude, longitude, ...restLocation } = location;
  const locationValues = Object.values(restLocation);
  return !isRemote &&
    !(locationValues.length && locationValues.every(value => value === null));
}

export const getCityState = ({location: {city, stateAbbreviation}}) =>
  `${city}, ${stateAbbreviation}`;

export const getVenue = ({location: {name}}) => name;

export const getPriceMinMax = event => {
  const {isFree, pricing} = event;
  if (isFree || !pricing) {
    return '';
  }
  const minPrice = pricing.reduce((min, p) => p.price < min ? p.price : min, pricing[0].price);
  const maxPrice = pricing.reduce((max, p) => p.price > max ? p.price : max, pricing[0].price);
  return `$${minPrice}${minPrice !== maxPrice ? ` - $${maxPrice}` : ''}`;
}

export const buildDetailDateStr = (event) => {
  const {
    startDate,
    endDate,
    timeZoneDescriptionLocal,
    timeZoneOffsetLocal,
  } = event;
  const offset = timeZoneOffsetLocal
    ? timeZoneOffsetLocal.split(':').slice(0, 2).join(':')
    : '00:00';

  const start = moment(startDate).utcOffset(offset);
  const end = moment(endDate).utcOffset(offset);

  if (start.isSame(end, 'day')) {
    // returns formated single date
    return (
      start.format('MMMM Do, YYYY[\n]h:mm a[ - ]') +
      end.format(`h:mm a [${timeZoneDescriptionLocal}]`)
    );
  }
  // formatted multi dates
  return (
    start.format(`MMMM Do, YYYY h:mm a [${timeZoneDescriptionLocal}] -[\n]`) +
    end.format(`MMMM Do, YYYY h:mm a [${timeZoneDescriptionLocal}]`)
  );
};


// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/data-helpers.js